import { Link, Navigate } from 'react-router';
import { AuthLayout } from './AuthLayout';
import { COPY } from './authErrors';
import { useSession } from './session';

/** /sign-up without a token: sign-up only happens from an invite link (/invite/:token). */
export function SignUpScreen() {
  const session = useSession();
  if (session.status === 'signed_in') return <Navigate to="/" replace />;
  return (
    <AuthLayout title="Sign up">
      <p>{COPY.inviteOnly}</p>
      <p className="text-sm text-muted">
        Already have an account?{' '}
        <Link to="/sign-in" className="text-primary underline">
          Sign in
        </Link>
      </p>
    </AuthLayout>
  );
}
